// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MfQa8","label":"styles_label__1Iszh"};